import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { updateTcOrder } from 'actions/tc/orders';
import PodPor from './PodPor';
import { Dialog, FlatButton, RaisedButton } from 'material-ui';
import _ from 'lodash';
import DateRangeSelector from 'components/Base/DateRangeSelector';
import moment from 'moment';

class PodPorsBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openLayCanDialog: false,
            openDialogs: {},
        };
    }

    getDefaultDelRedel = () => ({
        details: null,
        main: false,
        port: {
            _id: null,
            name: null,
        },
    })

    addNewPort = (type) => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder[`${type}Places`].push(this.getDefaultDelRedel());

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    removePort = (key, type) => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder[`${type}Places`].splice(key, 1);

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    changePortData = (key, type, port) => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder[`${type}Places`][key] = port;

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    handleCloseLayCanDialog = (index) => {
        this.setState({
            openDialogs: {
                ...this.state.openDialogs,
                [`dialog${index}`]: false,
            }, 
        });
    }

    handleOpenLayCanDialog = (index) => {
        this.setState({
            openDialogs: {
                ...this.state.openDialogs,
                [`dialog${index}`]: true,
            }, 
        });
    }

    changeLayCan = (dates) => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);
        const { readinessDate, cancellingDate } = dates;

        _tcOrder.readinessDate = readinessDate;
        _tcOrder.cancellingDate = cancellingDate;

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    render() {
        const {
            deliveryPlaces, redeliveryPlaces, cancellingDate, readinessDate, 
        } = this.props.tcOrder;
        const actions = [
            <FlatButton
                label="Ok"
                primary
                onClick={() => {
                    const entries = Object.entries(this.state.openDialogs);
                    return entries.forEach(entrie => entrie[1] && this.handleCloseLayCanDialog(entrie[0].substr(-1)));
                }}
            />,
        ];

        return (
            <div>
                <div className='row'>
                    <div className='col-xs-9' style={{ fontSize: '14px' }}>
                        Ports of delivery:
                    </div>
                    <div className='col-xs-3'>
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px', marginBottom: '10px' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Add new delivery port'
                            onClick={() => this.addNewPort('delivery')}
                            primary
                        />
                    </div>
                </div>
                {
                    deliveryPlaces && deliveryPlaces.map((portData, index) => (
                        <div 
                            style={{ width: '97%', marginLeft: '10px' }}
                            key={['deliveryPlaces', index].join('_')}
                        >
                            <div
                                className='row'
                                style={{ background: `${portData.main || index === 0 ? '#EEF8E4' : '#F5F5F5'}` }}
                            >
                                <div className='column-left'>
                                    {`Port of delivery - ${index + 1}`}
                                </div>
                            </div>
                            <div 
                                className='row'
                                style={{ background: `${portData.main || index === 0 ? '#EEF8E4' : '#F5F5F5'}` }}
                            >
                                <PodPor
                                    key={['podPor', index].join('_')}
                                    port={portData}
                                    portType='delivery'
                                    portIndex={index}
                                    changePortData={this.changePortData}
                                    removePort={this.removePort}
                                />
                                {
                                    index === 0 && <RaisedButton
                                        labelStyle={{ fontSize: '10px' }}
                                        style={{ height: '25px', margin: '35px 0 0 23px' }}
                                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                        label='Laycan'
                                        onClick={() => this.handleOpenLayCanDialog(index)}
                                        primary
                                    />
                                }
                                {
                                    index === 0 && 
                                    <span style={{ fontSize: '12px', fontWeight: 'bold', margin: '40px 0 0 5px' }}>
                                        {moment(readinessDate).utc().format('DD-MM-YYYY')} --- {moment(cancellingDate).utc().format('DD-MM-YYYY')} 
                                    </span>
                                }
                            </div>
                            <Dialog
                                title="Dialog With Date Picker"
                                actions={actions}
                                modal={false}
                                open={!!this.state.openDialogs[`dialog${index}`]}
                                onRequestClose={() => this.handleCloseLayCanDialog(index)}
                            >
                                <DateRangeSelector
                                    from={moment(readinessDate).utc().toDate()}
                                    until={moment(cancellingDate).utc().toDate()}
                                    fromLabel="Readiness date"
                                    untilLabel="Cancelling date"
                                    onChange={range => this.changeLayCan({ readinessDate: range.from, cancellingDate: range.until })}
                                />
                            </Dialog>
                            <br />
                        </div>
                    ))
                }

                <div className='row'>
                    <div className='col-xs-9' style={{ fontSize: '14px' }}>
                        Ports of redelivery:
                    </div>
                    <div className='col-xs-3'>
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px', marginBottom: '10px' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Add new redelivery port'
                            onClick={() => this.addNewPort('redelivery')}
                            primary
                        />
                    </div>
                </div>
                {
                    redeliveryPlaces && redeliveryPlaces.map((portData, index) => (
                        <div
                            style={{ width: '97%', marginLeft: '10px' }}
                            key={['redeliveryPlaces', index].join('_')}
                        >
                            <div
                                className='row'
                                style={{ background: `${portData.main || index === 0 ? '#E8F0F8' : '#F5F5F5'}` }}
                            >
                                <div className='column-left'>
                                    {`Port of redelivery - ${index + 1}`}
                                </div>
                            </div>
                            <div 
                                className='row'
                                style={{ background: `${portData.main || index === 0 ? '#E8F0F8' : '#F5F5F5'}` }}
                            >
                                <PodPor
                                    key={['podPor', index].join('_')}
                                    port={portData}
                                    portType='redelivery'
                                    portIndex={index}
                                    changePortData={this.changePortData}
                                    removePort={this.removePort}
                                />
                            </div>
                            <br />
                        </div>
                    ))
                }
            </div>
        );
    }
}

PodPorsBlock.propTypes = {
    tcOrder: PropTypes.object,
    numberOrderTable: PropTypes.number,
    updateTcOrder: PropTypes.func,
};

export default connect(
    ({ tcOrders: { items: tcOrders } }, ownProps) => ({
        tcOrders,
    }),
    dispatch => bindActionCreators({
        updateTcOrder,
    }, dispatch),
)(PodPorsBlock);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/content/podPor/PodPorsBlock.jsx